module.exports = __webpack_public_path__ + "assets/webgl/Assets_2_base_color.jpg.dxt.f8e53e9a.ktx";